<template>
  <div class="weeklymenu">
    <el-row class="row-title" v-if="weeklyMenuShow">
      <el-col :span="2">
        <kt-button label="编辑" type="primary" @click="handleEdit" />
      </el-col>
      <el-col :span="2" align="right" style="margin-right: 5px">
        <kt-button label="上一周" type="primary" @click="handlePrevWeek" />
      </el-col>
      <el-col :span="4">
        <el-date-picker :editable="false" :clearable="false" v-model="dateValue" type="date"
          :placeholder="weekmenue.placeTime" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
          @change="changdata"></el-date-picker>
      </el-col>
      <el-col :span="2">
        <kt-button label="下一周" type="primary" @click="handleNextWeek" />
      </el-col>
    </el-row>
    <el-row class="row-title" v-if="!weeklyMenuShow">
      <el-col :span="2">
        <kt-button label="返回" type="primary" @click="handleBack" />
      </el-col>
    </el-row>
    <el-row style="
        height: 54px;
        line-height: 54px;
        background: #f9f7fa;
        border: 1px #f1eff2 solid;
        margin-top: 20px;
      ">
      <el-col :span="2" style="font-size: 18px">
        <img src="@/assets/beadhouse/juxing.png" alt style="vertical-align: middle; margin: 0 10px" />
        <span>{{ weekmenue.weekMenue }}</span>
      </el-col>
      <el-col :span="6" :offset="16" align="right">
        <span style="margin-right: 15px">{{
          weekmenue.which +
          String(
            weeklyMenuList.length != 0 ? weeklyMenuList[0].week : ""
          ).substring(4) +
          weekmenue.week
        }}</span>
        <span style="margin-right: 15px">{{ weeklyMenuList.length != 0 ? weeklyMenuList[0].day : "" }}
          {{ weekmenue.to
          }}{{ weeklyMenuList.length != 0 ? weeklyMenuList[6].day : "" }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-table style="width: 100%" border :data="weeklyMenuList" :row-style="tableRowStyle"
        :header-cell-style="tableHeaderColor" :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        @cell-click="handleCellClick">
        <el-table-column :label="weekmenue.sunday" align="center" min-height="100" min-width="50"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.weekday }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="weekmenue.data" align="center" min-height="100" min-width="60"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.day }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="weekmenue.breakfast" align="center" min-height="100" min-width="100"
          :show-overflow-tooltip="true" style="cursor: pointer">
          <template slot-scope="scope">
            <div style="display: flex;text-align: center;">
              <div class="box_left_dv">{{ scope.row.breakfast }}</div>
              <div class="img_box" v-if="weeklyMenuShow && scope.row.breakfastPicture!=null && scope.row.breakfastPicture.length >0">
                <el-image class="img" :key="imgurl" :preview-src-list="scope.row.breakfastPicture.split(',')" v-if="imgurl.length>10" v-for="imgurl in scope.row.breakfastPicture.split(',')" :src="imgurl"/>
              </div>
              <div class="img_box" v-if="!weeklyMenuShow && scope.row.breakfastPicture!=null && scope.row.breakfastPicture.length >0">
                <el-image class="img" :key="imgurl" v-for="imgurl in scope.row.breakfastPicture.split(',')" v-if="imgurl.length>10" :src="imgurl"/>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="weekmenue.lunch" align="center" min-height="100" min-width="100"
          :show-overflow-tooltip="true" style="cursor: pointer">
          <template slot-scope="scope">
            <div style="display: flex;text-align: center;">
              <div class="box_left_dv">{{ scope.row.lunch }}</div>
              <div class="img_box" v-if="weeklyMenuShow &&scope.row.lunchPicture!=null && scope.row.lunchPicture.length >0">
                <el-image class="img" :key="imgurl" :preview-src-list="scope.row.lunchPicture.split(',')" v-if="imgurl.length>10" v-for="imgurl in scope.row.lunchPicture.split(',')" :src="imgurl"/>
              </div>
              <div class="img_box" v-if="!weeklyMenuShow &&scope.row.lunchPicture!=null && scope.row.lunchPicture.length >0">
                <el-image class="img" :key="imgurl" v-for="imgurl in scope.row.lunchPicture.split(',')" v-if="imgurl.length>10" :src="imgurl"/>
              </div>
            </div>

          </template>
        </el-table-column>
        <el-table-column :label="weekmenue.dinner" align="center" min-height="100" min-width="100"
          :show-overflow-tooltip="true" style="cursor: pointer">
          <template slot-scope="scope">
            <div style="display: flex;text-align: center;">
              <div class="box_left_dv">{{ scope.row.dinner }}</div>
              <div class="img_box" v-if="weeklyMenuShow && scope.row.dinnerPicture!=null && scope.row.dinnerPicture.length >0">
                <el-image class="img" :key="imgurl" :preview-src-list="scope.row.dinnerPicture.split(',')" v-if="imgurl.length>10" v-for="imgurl in scope.row.dinnerPicture.split(',')" :src="imgurl"/>
              </div>
               <div class="img_box" v-if="!weeklyMenuShow && scope.row.dinnerPicture!=null && scope.row.dinnerPicture.length >0">
                <el-image class="img" :key="imgurl" v-for="imgurl in scope.row.dinnerPicture.split(',')" v-if="imgurl.length>10" :src="imgurl"/>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 点击表格的单个单元格弹出dialog模态框-->
    <el-dialog class="weeklymenudialog" title="每餐菜品" width="600px" :visible.sync="dialogVisibleAddFood"
      :close-on-click-modal="false" center>
      <el-form :model="addFood" label-width="100px" style="margin-top: 30px;" :rules="addFoodRules" ref="addFoodaa" label-position="right">
          <el-form-item label="菜品名称">
            <el-input v-model.trim="foodName" ref="foodName" auto-complete="off" type="textarea"
            :rows="3" style="width:95%;"></el-input>
          </el-form-item>
          <el-form-item label="菜品照片">
            <el-upload action="string" accept="image/png, image/jpeg" list-type="picture-card"
                :file-list="addFileList" :before-upload="beforeAvatarUploadPicB"
                :http-request="uploadSectionFilePicB" 
                :on-remove="handleRemove"
                :on-preview="handlePictureCardPreview"
                :limit="5">
                <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleAddFood = false">
          取消</el-button>
        <el-button type="primary" @click="submitFormAddFood">
          确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible" width="640px" style="margin-top: -50px;">
      <img width="600px" :src="dialogImageUrl" alt="">
    </el-dialog>

  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
import util from "@/utils/util.js";
export default {
  name: "WeeklyMenu",
  components: { KtTable, KtButton },
  data() {
    return {
      weekmenue: {
        placeTime: "请选择时间",
        weekMenue: "每周菜谱",
        which: "第",
        week: "周",
        to: "至",
        sunday: "星期",
        data: "日期",
        breakfast: "早餐",
        lunch: "中餐",
        dinner: "晚餐",
        addFood: "添加食物"
      }, //引入中文字符串
      weeklyMenuShow: true,
      loading: true,
      size: "medium", //按钮的尺寸
      dateValue: util.formatDate.format(new Date(), "yyyy-MM-dd"),
      weeklyMenuList: [], //每周菜谱的table
      //添加食物的dialo配置
      dialogVisibleAddFood: false,
      addFood: {},
      addFoodRules: {},
      addFoodLoading: false,
      checkedFoods: [], //被选中的
      filterFood: [], //所有食物
      active: [true, false, false], //统一管理状态,默认第一个被选中;
      tab: [{ menuName: "主食" }, { menuName: "菜品" }, { menuName: "汤类" }], //菜单的tab集合
      columnId: "",
      timefood: "", //早中晚餐
      foodName:"",
      addFileList:[],
      addFileUrl: [],
      fileDataList:[],
      dialogVisible:false,
      dialogImageUrl:'',
    };
  },
  methods: {
    //上一周
    handlePrevWeek() {
      // 获得当前日期
      var doday = new Date(this.dateValue);
      doday = Date.parse(doday);
      // 将当前日期减去1天的时间
      doday = doday - 1000 * 60 * 60 * 24 * 7;
      // timeFormat()日期格式化
      var nowDate = util.formatDate.format(new Date(doday));
      // 获得value
      this.dateValue = nowDate;
      this.addWeekMenue();
      //this.getweekMenu()
    },
    //下一周
    handleNextWeek() {
      // 获得当前日期
      var doday = new Date(this.dateValue);
      doday = Date.parse(doday);
      // 将当前日期加上1天的时间
      doday = doday + 1000 * 60 * 60 * 24 * 7;
      // timeFormat()日期格式化
      var nowDate = util.formatDate.format(new Date(doday));
      // 获得value
      this.dateValue = nowDate;
      this.addWeekMenue();
    },
    changdata(val) {
      this.dateValue = val;
      this.addWeekMenue();
    },
    //获取数据
    getweekMenu() {
      this.$postForm("omc/menu/menuShowAll", {
        day: this.dateValue,
      }).then((res) => {
        if (res.code == 200) {
          //添加星期字段
          let newList = res.result.map((item) => {
            item.weekday = new Date(item.day).getDay();
            return item;
          });
          //编辑星期
          var maps = new Map([
            [1, "星期一"],
            [2, "星期二"],
            [3, "星期三"],
            [4, "星期四"],
            [5, "星期五"],
            [6, "星期六"],
            [0, "星期日"],
          ]);
          this.weeklyMenuList = newList.map((element) => {
            element.weekday = maps.get(element.weekday);
            return element;
          });
        } else {
          this.weeklyMenuList = res.result;
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
    beforeAvatarUploadPicB(file) {
            let isPNG = false;
            let isImage = false;
            file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
            isImage = file.type.match("image") != "image" ? false : true;
            const isLt2M = file.size / 1024 / 1024 < 5;
            if (!isImage) {
                this.$message.error("上传图片格式错误");
            }
            if (!isPNG) {
                this.$message.error("上传图片格式不能是 gif 格式");
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 5MB");
            }
            //by guo 2020-6-30-16:12添加判断  当所有验证通过之后才将该图片添加进数组中
            if (isPNG && isLt2M && isImage) {
                // this.addFileList.push(file);
                return true;
            }
            return isPNG && isLt2M && isImage;
        },
        handlePictureCardPreview(file){
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
        },
        handleRemove(file, fileList) {
          console.log(file);
          console.log(this.fileDataList);
          for (let i = 0; i < this.fileDataList.length; i++) {
              if (file.uid == this.fileDataList[i].uid) {
                  this.fileDataList.splice(i, 1);
                  this.addFileUrl.splice(i, 1);
              }
          }
          console.log(this.addFileUrl);
        },
        uploadSectionFilePicB(param) {
            var fileObj = param.file;
            if (fileObj != undefined) {
                this.fileDataList.push(fileObj);
                // FormData 对象
                var form = new FormData();
                // 文件对象
                form.append("file", fileObj);
                form.append("fileType", "picture");
                form.append("bucketName", "cmny-oss");
                this.$postFormData("dmc/file/uploadFile", form).then(res => {
                    if (res.code == 200) {
                        this.$message({
                            type: "success",
                            message: res.message
                        });
                        this.addFileUrl.push(res.result);
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                });
            }
    },

    //编辑按钮
    handleEdit() {
      this.weeklyMenuShow = false;
    },
    //返回按钮
    handleBack() {
      this.weeklyMenuShow = true;
    },
    //点击单个单元格
    handleCellClick(row, column, cell, event) {
      this.active = [true, false, false];
      let index = "0"; //编辑菜单默认为主食
      this.getfoodList(index); //食物初始化
      this.columnId = row.id;
      this.timefood = column.label;
      // let nowDay = new Date(util.formatDate.format(new Date(), "yyyy-MM-dd")); //今日时间
      // if (new Date(row.day) < nowDay && this.weeklyMenuShow == false) {
      //   this.$alert("今日之前记录不能编辑", "提示", {
      //     confirmButtonText: "确定",
      //     center: true,
      //     callback: (action) => { },
      //   });
      // } else 
      if (
        this.weeklyMenuShow == false &&
        (column.label == "早餐" ||
          column.label == "中餐" ||
          column.label == "晚餐")
      ) {
        this.dialogVisibleAddFood = true;
        this.foodName =
          column.label == "早餐"
            ? (row.breakfasts?row.breakfasts[0]:"")
            : column.label == "中餐"
              ? (row.lunchs?row.lunchs[0]:"")
              : column.label == "晚餐"
                ? (row.dinners?row.dinners[0]:"")
                : [];
        //addFileList
        this.addFileUrl =
          column.label == "早餐"
            ? row.breakfastPicture
            : column.label == "中餐"
              ? row.lunchPicture
              : column.label == "晚餐"
                ? row.dinnerPicture
                : '';
        if (this.addFileUrl == null){
          this.addFileUrl = [];
        }else{
          this.addFileUrl = this.addFileUrl.split(",");        
        }
        this.addFileList = [];
        this.fileDataList = [];
        this.addFileUrl.forEach(element => {
          if(element.length>10){
            this.addFileList.push({
              name: element,
              url: element,
              uid: element,
              status: 'done'
            })
            this.fileDataList.push({
              name: element,
              url: element,
              uid: element,
              status: 'done'
            })
          }
        });
      }
    },

    //查询所有食物
    getfoodList(index) {
      this.$postForm("omc/food/selectByType", {
        foodType: Number(index + 1),
      }).then((res) => {
        this.filterFood = res.result;
      });
    },

    //添加周菜谱
    addWeekMenue() {
      //判断菜谱是否存在如果不存在添加
      this.$postForm("omc/menu/selectByDay", { day: this.dateValue }).then(
        (res) => {
          if (res.result == 0) {
            //不存在添加菜谱
            this.$postForm("omc/menu/menuAdd", { day: this.dateValue }).then(
              (res) => {
                this.getweekMenu(); //查询菜谱
              }
            );
          } else {
            this.getweekMenu();
          }
        }
      );
    },
    //编辑菜谱
    submitFormAddFood() {
      console.log(this.addFileUrl);
      
      let filrUrls = this.addFileUrl.join(",");
      if (filrUrls.length<10){
        filrUrls = "";
      }
      console.log(filrUrls);
      let breakfast =
        this.timefood == "早餐"
          ? this.foodName
          : this.weeklyMenuList.breakfast; //早餐
      let breakfastPicture =
        this.timefood == "早餐"
          ? filrUrls
          : this.weeklyMenuList.breakfastPicture; //早餐
      let lunch =
        this.timefood == "中餐"
          ? this.foodName
          : this.weeklyMenuList.lunch; //中餐
      let lunchPicture =
        this.timefood == "中餐"
          ? filrUrls
          : this.weeklyMenuList.lunchPicture; //早餐
      let dinner =
        this.timefood == "晚餐"
          ? this.foodName
          : this.weeklyMenuList.dinner; //晚餐
      let dinnerPicture =
        this.timefood == "晚餐"
          ? filrUrls
          : this.weeklyMenuList.dinnerPicture; //早餐
      let param = {
        menus: [
          {
            id: Number(this.columnId),
            breakfast: breakfast,
            lunch: lunch,
            dinner: dinner,
            breakfastPicture: breakfastPicture,
            lunchPicture: lunchPicture,
            dinnerPicture: dinnerPicture,
          },
        ],
      };
      this.$postJson("omc/menu/menuUpdate", param).then((res) => {
        if (res.code == 200) {
          this.dialogVisibleAddFood = false; //关闭弹窗
          this.getweekMenu(); //刷新页面
          // this.$nextTick(() => {
          //   this.$refs["addFood"].resetFields();
          // });
          this.$message({ message: res.message, type: "success" });
        } else {
          this.$message({ message: res.message, type: "error" });
        }
      });
    },
    //左边的tab切换
    changeMenu(x, menuName) {
      this.getfoodList(x);
      for (var i = 0; i < this.active.length; i++) {
        this.active[i] = false;
        this.active[x] = true;
      }
      this.$set(this.active, 3, 0);
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
  },
  created() { },
  mounted() {
    this.getweekMenu();
    // let index = "0";
    // this.getfoodList(index);
    this.addWeekMenue();
  },
};
</script>
<style lang="scss" scoped>
.weeklymenu {
  width: 100%;
  min-height: 95%;
  background: #fefefe;

  .menu-ctrl {
    background: #fff;
    display: inline-block;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    cursor: pointer;
    color: rgb(100, 92, 92);
    border: 1px solid rgb(243, 234, 234);
    padding: 20px;
    font-size: 16px;
    font-weight: 500;
  }

  .menu-ctrl.active {
    color: #fff;
    background: #09a3c1;
  }

  .btn {
    width: 587px;
    height: 144px;
    position: absolute;
    bottom: -131px;
    right: 0;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

// ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: center;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

.weeklyGroup {
  padding: 0 0 10px 0;
  overflow-y: auto;
}
.box_left_dv{
    width: 40%;
    text-align: center;
    word-wrap: break-word;
    display: block;
    white-space: pre-wrap;
    max-lines: 3;
}
.img_box{
  flex:1;
  display:flex;
  width: 60%;
  height:60px;
  .img{
    width:58px;
    height:58px;
    margin:1px;
  }
}
::v-deep .weeklymenudialog .el-dialog .el-dialog__body {
  padding: 0 0 10px 0;
}

::v-deep .el-dialog__header {
  height: 19px !important;
  text-align: left;
}

::v-deep .el-dialog__footer {
  text-align: center;
}
</style>
